import { Link } from 'react-router';

import MoreIcon from '@asset/more.icon.svg?react';
import { Wrapper } from '@atom/read-more/read-more.style';
import { Text } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';

interface ReadMoreProps {
  to: string;
  title?: string;
  target?: string;
}

export const ReadMore = ({ to, title = 'Read More', target }: ReadMoreProps) => (
  <Link target={target} to={to}>
    <Wrapper>
      <MoreIcon />
      <Text color={ColorEnum.Teal150} level='m'>
        {title}
      </Text>
    </Wrapper>
  </Link>
);
